"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var curation_actions_1 = require("../actions/curation_actions");
var CuratedSetToggle = /** @class */ (function (_super) {
    tslib_1.__extends(CuratedSetToggle, _super);
    function CuratedSetToggle(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleCuration = _this.toggleCuration.bind(_this);
        return _this;
    }
    Object.defineProperty(CuratedSetToggle.prototype, "id", {
        get: function () {
            return this.props.set.curated_set_id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CuratedSetToggle.prototype, "fieldId", {
        get: function () {
            return "curated_set_" + this.id;
        },
        enumerable: true,
        configurable: true
    });
    CuratedSetToggle.prototype.toggleCuration = function (evt) {
        if (evt.target.checked) {
            curation_actions_1.default.curate(this.id);
            return;
        }
        curation_actions_1.default.decurate(this.id);
    };
    CuratedSetToggle.prototype.renderSaleTag = function () {
        if (this.props.set.has_sale) {
            return React.createElement("span", { className: "fa fa-tag ml-half" });
        }
        return null;
    };
    CuratedSetToggle.prototype.render = function () {
        if (!this.fieldId) {
            return null;
        }
        return (React.createElement("div", { className: "admin-curation-dialog__item" },
            React.createElement("input", { type: "checkbox", name: this.fieldId, id: this.fieldId, checked: this.props.set.curated, onChange: this.toggleCuration }),
            React.createElement("label", { htmlFor: this.fieldId },
                this.props.set.curated_set_name,
                this.renderSaleTag())));
    };
    return CuratedSetToggle;
}(React.Component));
CuratedSetToggle.defaultProps = {
    set: {
        curated: false,
    },
};
CuratedSetToggle.propTypes = {
    set: PropTypes.shape({
        curated_set_id: PropTypes.number.isRequired,
        has_sale: PropTypes.bool,
        curated: PropTypes.bool,
        curated_set_name: PropTypes.string,
    }),
};
exports.default = CuratedSetToggle;
//# sourceMappingURL=curated_set_toggle.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/curation/curated_set_toggle.js
// module id = +s2X
// module chunks = 20 21